import { Add, Information } from '@carbon/icons-react';
import { Button, Checkbox, Form, Stack, TextInput } from '@carbon/react';
import React, { useEffect, useState } from 'react';
import jwt_decode from 'jwt-decode';
import { useDispatch } from 'react-redux';
import { setUserLoginDetails } from '../Redux/Actions/User';
import { useNavigate, useLocation } from 'react-router-dom';
import { setLoggedUser, setLoggedUserToken, userAuth } from '../Utils/common';
import { emailValidation } from '../Utils/Regex';
import { authAPI } from '../API/Auth';
import Toaster from '../Components/Common/Toaster';
import MainLoader from '../Components/Common/Loader/MainLoader';
import { CLIENT_ID, GOOGLE_REDIRECT_URL } from '../Utils/config';

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [loginForm, setLoginForm] = useState({ email: '', password: '' });
  const [toaster, setToaster] = useState(false);
  const [loading, setLoading] = useState(false);
  const [toastError, setToastError] = useState({});
  const [loginError, setLoginError] = useState({
    email: false,
    password: false,
  });

  useEffect(() => {
    window?.google?.accounts?.id?.initialize({
      client_id: CLIENT_ID,
      ux_mode: 'redirect',
      login_uri: `${GOOGLE_REDIRECT_URL}auth/google?redirect=${window.location?.href}`,
    });
    window?.google?.accounts?.id?.renderButton(
      document.getElementById('signInDiv'),
      {
        theme: 'outline',
        size: 'large',
      }
    );
  }, []);

  useEffect(() => {
    const token = new URL(window.location.href).searchParams.get('token');
    if (token) {
      try {
        const userData = jwt_decode(token);
        if (userData && Object.keys(userData)?.length) {
          setLoggedUser(userData);
          setLoggedUserToken(token);
          dispatch(setUserLoginDetails(userData));
          document.getElementById('signInDiv').hidden = true;
          navigate('/home');
        }
      } catch (e) {}
    }
  }, [dispatch, navigate]);

  useEffect(() => {
    if (window.location.pathname !== '/login') {
      window.location.href = '/login';
    }
    if (userAuth()) navigate('/home');
  }, []);

  const handleChange = (e) => {
    const { name, value } = e?.target || e;
    setLoginForm({
      ...loginForm,
      [name]: value,
    });
  };

  const handleSubmit = async () => {
    const { email, password } = loginForm;
    let error = {};
    if (!password) {
      error.password = 'Password is required';
    }
    if (!email) {
      error.email = 'Email is required';
    } else {
      const value = emailValidation(email);
      if (!value) {
        error.email = 'Please enter valid email';
      } else {
        delete error.email;
      }
    }

    if (Object.keys(error).length) {
      setLoginError(error);
      return;
    }
    setLoading(true);
    const res = await authAPI?.login(loginForm);
    if (res && res?.length && res?.[0]) {
      setLoading(false);
      setToastError({
        title: 'API Fail',
        message: res[1]?.message || 'Something went to wrong!',
        type: 'error',
      });
      setToaster(true);
    } else {
      setLoading(false);
      setToaster(false);
      if (res?.[1]?.data) {
        setLoggedUser(res?.[1]?.data?.user);
        setLoggedUserToken(res?.[1]?.data?.token);
        dispatch(setUserLoginDetails(res?.[1]?.data?.user));
        navigate('/home');
      }
    }
  };

  return (
    <div className="login-form">
      {toaster && (
        <Toaster
          title={toastError?.title}
          type={toastError?.type}
          message={toastError?.message}
          handleCloseToaster={() => setToaster(false)}
        />
      )}
      {loading && <MainLoader />}
      <div className="login-box">
        <h2 className="title">Log in</h2>
        <Form>
          <Stack gap={5}>
            <TextInput
              labelText="Email"
              placeholder="Email"
              name="email"
              value={loginForm?.email || ''}
              onChange={handleChange}
              required={false}
              id="email"
            />
            {loginError?.email && (
              <label className="red-text">{loginError?.email}</label>
            )}
            <TextInput.PasswordInput
              id="password"
              labelText="Password"
              placeholder="Password"
              name="password"
              value={loginForm?.password || ''}
              onChange={handleChange}
              required={false}
            />
            {loginError?.password && (
              <label className="red-text">{loginError?.password}</label>
            )}
            <div className="remember">
              <Checkbox labelText="Remember me" id="remember" />
              <Information />
            </div>
            <div className="button-wrap">
              <Button
                className="cursor-pointer"
                renderIcon={Add}
                kind="primary"
                onClick={handleSubmit}
                tabIndex={0}
                type="button"
              >
                Login
              </Button>
              <div id="signInDiv" className="sign-in-button"></div>
            </div>
          </Stack>
        </Form>
      </div>
    </div>
  );
};

export default Login;
